import React from 'react';
import { getLabel } from '../../../data/labels';
import { getConfiguration } from '../../utils';
import BorderedTicketSelections from '../bordered-ticket/BorderedTicketSelections';
import BorderedTicketTuples from '../bordered-ticket/BorderedTicketTuples';

function BorderedTicketBody(props) {
	
	const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; 
	const user = props.user;
	const isCashout = props.isCashout;
	const conf = getConfiguration();
	let accountId = '';
	let identityPlayer = '';
	if(user != null){
		accountId = user.accountNum? user.accountNum : '';
		identityPlayer = user.cf? user.cf : '';
	}
	
	
	const isTerminal = frontendType === 'TERMINAL' || frontendType === 'SELF-CASHIER';
	let ticketType = (ticketData.purchaseType === 'systembets' ? 
		    getLabel('printer.plain_ticket.header.system_bets')
		    : 
            (ticketData.purchaseType === 'singlebets' ? getLabel('printer.plain_ticket.header.single_bets') : getLabel('printer.plain_ticket.header.multiple_bets'))
          );

	ticketType = ticketType + " " + (ticketData.psv? "PSV" : getLabel('printer.plain_ticket.header.fixed_odds'));

	if(isCashout){
		ticketType = ticketType + " - " + getLabel('cashout.translation');
	}

	const terminalCopy = props.terminalCopy;
	const companyName = conf.tad? conf.tad.cmpn : '';
	const hideOperator = conf.tad && conf.tad.hop;
	const hideAgency = conf.tad && conf.tad.hag;
	
	return  <>
		<div className="div-table">
			{
				companyName !== '' && (
						<div className="companyName"> {companyName} </div>
				
				)
			}
			<div className="metadata-subtable">
				{
					frontendType === 'ONLINE' && <>
						{
							accountId.length > 0 &&  aamsEnviroment &&(
								<div className="metadata-row">
									<div className="metadata-key">{getLabel('printer.bordered_ticket.header.account_number')}</div>
									<div className="metadata-value">{accountId}</div>
									<div className="clear"></div>
								</div>
							)
						}

						{
							identityPlayer.length > 0 && (
								<div className="metadata-row">
									<div className="metadata-key">{getLabel('printer.bordered_ticket.header.cf')}</div>
									<div className="metadata-value">{identityPlayer}</div>
									<div className="clear"></div>
								</div>
							)
						}

					</>
				}

				<div className="metadata-row">
					<div className="metadata-key">{getLabel('printer.bordered_ticket.body.issue_date')}</div>
					<div className="metadata-value">{ticketData.ge + ' ' + ticketData.oe} </div>
					<div className="clear"></div>
				</div>
				{
					aamsEnviroment && isTerminal && <>
					<div className="metadata-row">
						<div className="metadata-key">{getLabel('printer.bordered_ticket.header.pv')}</div>
						<div className="metadata-value">{ticketData.pv}</div>
						<div className="clear"></div>
					</div>
					<div className="metadata-row">
						<div className="metadata-key">{getLabel('printer.bordered_ticket.header.tm')}</div>
						<div className="metadata-value">{ticketData.tm}</div>
						<div className="clear"></div>
					</div>
					<div className="metadata-row">
						<div className="metadata-key">{getLabel('printer.bordered_ticket.header.nc')}</div>
						<div className="metadata-value">{ticketData.nc}</div>
						<div className="clear"></div>
					</div>
					<div className="metadata-row">
						<div className="metadata-key">{getLabel('printer.bordered_ticket.header.tg')}</div>
						<div className="metadata-value">{ticketData.tg}</div>
						<div className="clear"></div>
					</div>
					<div className="metadata-row">
						<div className="metadata-key">{getLabel('printer.bordered_ticket.header.gr')}</div>
						<div className="metadata-value">{ticketData.gr}</div>
						<div className="clear"></div>
					</div>
					</>
				}

				
				{
					!aamsEnviroment && isTerminal && <>
						<div className="metadata-row">
							<div className="metadata-key">{getLabel('printer.bordered_ticket.body.terminal_number')}</div>
							<div className="metadata-value">{ticketData.tm}</div>
							<div className="clear"></div>
						</div>
						{
							frontendType === 'TERMINAL' && !hideOperator && (
								<div className="metadata-row">
									<div className="metadata-key">{getLabel('printer.bordered_ticket.body.operator')}</div>
									<div className="metadata-value">{ticketData.operator}</div>
									<div className="clear"></div>
								</div>
							)
						}
						{
							!hideAgency && (
								<div className="metadata-row ">
									<div className="metadata-key">{getLabel('printer.bordered_ticket.body.agency')}</div>
									<div className="metadata-value">{ticketData.agency}</div>
									<div className="clear"></div>
								</div>
							)
						}

					</>
				}

			</div>
			<div className="table-line"></div>
			
			<div className="ticket-type-subtable">
				<div className="ticket-type-row">{ticketType}</div>
			</div>
			{
				(frontendType === 'ONLINE' || terminalCopy) && (
					<div className="ticket-type-subtable">
						<div className="ticket-type-row">{getLabel('printer.bordered_ticket.body.copy')}</div>
					</div>
				)
			}
			<div className="table-line"></div>
			<BorderedTicketSelections  ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		</div>
		{
			ticketData.purchaseType === 'systembets' && (<BorderedTicketTuples  ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />)	
		}
	</>
}

export default BorderedTicketBody;